import * as React from "react";
import { Fragment } from 'react';
import { makeStyles } from '@mui/material/styles';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import { Pagination, BulkDeleteWithConfirmButton, Button, Confirm, Filter, NullableBooleanInput, ReferenceInput, SelectInput, TextInput, useNotify, useRefresh, useUnselectAll, useUpdateMany, ReferenceArrayField } from 'react-admin';
import { List, Datagrid, TextField, DateField, BooleanField, ReferenceManyField, ArrayField, SingleFieldList, ChipField } from 'react-admin';
import { SubPathEdit } from "./subPath.edit.component";

const PathBulkActionButtons = (props: any) => {
    const [selectedIds, setSelectedIds] = React.useState(props.selectedIds);
    const [isActive, setIsActive] = React.useState('');

    const [openStatusConfirm, setOpenStatusConfirm] = React.useState(false);
    const [openGroomedConfirm, setOpenGroomedConfirm] = React.useState(false);
    const refresh = useRefresh();
    const notify = useNotify();
    const unselectAll = useUnselectAll('snowmobile/subpaths');

    const [updateManyWithStatus, { isLoading: loadingManyWithStatus }] = useUpdateMany(
        'snowmobile/subpaths',
        {
            ids: selectedIds,
            data: { status: isActive },
        },
        {
            onSuccess: () => {
                refresh();
                notify('Paths updated');
                unselectAll();
            },
            onError: error => notify(`Error: paths not updated with status: "${isActive}".`, {type: 'warning'}),
        }
    );

    const [updateManyAsGroomed, { isLoading: loadingManyAsGroomed }] = useUpdateMany(
        'snowmobile/subpaths',
        {
            ids: selectedIds,
            data: { groomedAt: new Date() },
        },
        {
            onSuccess: () => {
                refresh();
                notify('Paths updated');
                unselectAll();
            },
            onError: error => notify(`Error: paths failed to update groom.`, {type: 'warning'}),
        }
    );

    // const handleClick = () => setOpenStatusConfirm(true);
    const handleStatusDialogClose = () => setOpenStatusConfirm(false);

    const handleGroomedDialogClose = () => setOpenGroomedConfirm(false);

    const handleConfirmForStatus = () => {
        updateManyWithStatus();
        setOpenStatusConfirm(false);
    };

    const handleConfirmForGroomed = () => {
        updateManyAsGroomed();
        setOpenStatusConfirm(false);
    };

    React.useEffect(() => {
        setIsActive('');
        setSelectedIds(props.selectedIds);
    }, [props.selectedIds, selectedIds]);

    const handleChange = (event: any) => {
        console.log('status');
        setOpenStatusConfirm(true)
        setIsActive(event.target.value);
    };

    return (
        <Fragment>
            <FormControl style={{ position: 'relative', top: '-8px' }}>
                <InputLabel shrink id="demo-simple-select-placeholder-label-label">Set status</InputLabel>
                <Select
                    variant="standard"
                    value={isActive}
                    onChange={handleChange}
                    displayEmpty
                >
                    <MenuItem value="" disabled>
                        <em>Select One</em>
                    </MenuItem>
                    <MenuItem value="open" selected>open</MenuItem>
                    <MenuItem value="closed">closed</MenuItem>
                    {/*<MenuItem value="freshlyGroomed">freshly groomed</MenuItem>*/}
                </Select>
                {/*<FormHelperText>Label + placeholder</FormHelperText>*/}
            </FormControl>
            <Confirm
                isOpen={openStatusConfirm}
                loading={loadingManyWithStatus}
                title="Update paths with status"
                content={`Are you sure you want set the status to "${isActive}" for these items?`}
                onConfirm={handleConfirmForStatus}
                onClose={handleStatusDialogClose}
            />
            <Confirm
                isOpen={openGroomedConfirm}
                loading={loadingManyAsGroomed}
                title="Update paths as groomed"
                content={`Are you sure you want to groom these items?`}
                onConfirm={handleConfirmForGroomed}
                onClose={handleGroomedDialogClose}
            />
            <Button color="primary" variant="outlined" label="Groomed" onClick={() => setOpenGroomedConfirm(true)} />
            {/*<Button label="Save" onClick={handleClick} />*/}
            <BulkDeleteWithConfirmButton  {...props} />
        </Fragment>
    );
}

const PathFilter = props => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn resettable/>
        <ReferenceInput source="areas" target="id" reference="areas" alwaysOn>
            <SelectInput variant="filled" optionText="name" label="Area" emptyText="All areas" />
        </ReferenceInput>
        <SelectInput variant="filled" source="status" emptyText="All statuses" alwaysOn choices={[
            { id: 'open', name: 'open' },
            { id: 'closed', name: 'closed' },
        ]} />
        <SelectInput variant="filled" source="zone" emptyText="All zones" alwaysOn choices={[
            { id: 'high', name: 'high' },
            { id: 'low', name: 'low' },
        ]} />
        {/*<Button variant="text" onClick={() => props.setFilters({})} label="Clear filters"/>*/}
    </Filter>
);

const PathPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;

export const SubPathList = () => {
    return (
        <List
            perPage={25}
            pagination={<PathPagination />}
            filters={<PathFilter/>}
            exporter={false}
        >
            <Datagrid rowClick="edit" expand={<SubPathEdit/>} bulkActionButtons={<PathBulkActionButtons />}>
                <TextField source="name" />
                <DateField source="groomedAt" options={{ day: '2-digit', hour: '2-digit', minute: '2-digit', month: 'short' }}/>
                <TextField source="status" />
                <TextField source="zone" />
                <ReferenceArrayField
                    source="area_ids"
                    reference="areas"
                    sortable={false}
                >
                    <SingleFieldList linkType={false}>
                        <ChipField color="secondary" source="name" />
                    </SingleFieldList>
                </ReferenceArrayField>
            </Datagrid>
        </List>
    );
}

export default SubPathList;
